import React from "react";
import { useTheme } from "./ThemeContext";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const StaffModal = ({
  show,
  onClose,
  roles,
  selectedRoles,
  onCheck,
  onSend,
  selectedEmp,
  loading,
}) => {
  const { isDark } = useTheme();

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header
        closeButton
        className={isDark ? "bg-dark text-light border-secondary" : ""}
      >
        <Modal.Title>{selectedEmp?.display_name || "Staff"}</Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={isDark ? "bg-dark text-light" : ""}
      >
        {roles.length === 0 ? (
          <div className={isDark ? "text-secondary text-center" : "text-muted text-center"}>
            No appraisal form available for this staff.
          </div>
        ) : (
          roles.map((role) => (
            <div
              key={role.role_id}
              className={`p-3 rounded d-flex justify-content-between align-items-center mb-2 ${
                isDark ? "bg-secondary bg-opacity-25 text-light border border-secondary" : "bg-white border"
              }`}
            >
              <div className="fw-bold">
                {role.display_name} ({role.type})
              </div>
              <Form.Check
                type="checkbox"
                checked={!!selectedRoles[role.role_id]}
                onChange={() => onCheck(role.role_id)}
              />
            </div>
          ))
        )}
      </Modal.Body>

      <Modal.Footer className={isDark ? "bg-dark border-secondary" : ""}>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="outline-light"
          style={{ background: "#B31E8D", color: "white" }}
          onClick={onSend}
          disabled={roles.length === 0}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> &nbsp;Sending...
            </>
          ) : (
            "Send"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StaffModal;
